import { VueRenderer } from '@tiptap/vue-3';
import tippy, { sticky } from 'tippy.js';
import Fuse from 'fuse.js';

import RichTextMentionList from '../components/all/RichTextMentionList.vue';

export default function createSuggestion(
  allItems,
  popupRef,
  defaultItems = {}
) {
  return {
    allowedPrefixes: [' ', '('],
    items: ({ editor, query }) => {
      const filterredItems = [];
      let all = allItems;
      if (typeof allItems === 'function') {
        all = allItems(query);
      }
      all.forEach((type, index) => {
        if (!query) {
          type.items = type.items.map(item => {
            item.underscored_name = item.mention_name.replace(/\s+/g, '_');
            return item;
          });
          filterredItems.push({
            ...type,
            items: [...type.items],
          });
        } else {
          const fuse = new Fuse(type.items, {
            threshold: 0.2,
            keys: ['mention_name', 'underscored_name'],
          });
          const searchResults = fuse.search(query);

          filterredItems.push({
            ...type,
            items: searchResults,
          });
        }

        if (Array.isArray(defaultItems[type.type])) {
          filterredItems[index].items.unshift(...defaultItems[type.type]);
        }
      });
      return filterredItems;
    },

    command: ({ editor, range, props }) => {
      // increase range.to by one when the next node is of type "text"
      // and starts with a space character
      const { nodeAfter } = editor.view.state.selection.$to;
      const overrideSpace = nodeAfter?.text?.startsWith(' ');

      if (overrideSpace) {
        range.to += 1;
      }

      const content = [
        {
          type: 'mention',
          attrs: props,
        },
      ];

      if (!editor.isActive('CustomCodeBlockLowLight')) {
        content.push({
          type: 'text',
          text: ' ',
        });
      }

      editor.chain().focus().insertContentAt(range, content).run();

      window.getSelection()?.collapseToEnd();
    },

    isPopupActive: () => {
      if (popupRef.value) {
        return true;
      }
      return false;
    },

    render: () => {
      let component;
      let popup;

      return {
        onStart: props => {
          // reference https://tiptap.dev/api/nodes/mention#usage
          component = new VueRenderer(RichTextMentionList, {
            props,
            editor: props.editor,
          });

          if (!props.clientRect) {
            return;
          }

          popup = tippy('.panzoom', {
            getReferenceClientRect: props.clientRect,
            appendTo: () => document.body,
            content: component.element,
            allowHTML: true,
            trigger: 'manual',
            interactive: true,
            theme: 'arcweave',
            placement: 'top-start',
            showOnCreate: true,
            plugins: [sticky],
            inertia: true,
            duration: [400, 200],
            zIndex: 10001,
          });
          popupRef.value = popup;
        },

        onUpdate(props) {
          component.updateProps(props);

          if (!props.clientRect) {
            return;
          }

          popupRef.value[0].setProps({
            getReferenceClientRect: props.clientRect,
          });
        },

        onKeyDown(props) {
          if (props.event.key === 'Escape') {
            popupRef.value[0].hide();
            return true;
          }

          return component.ref?.onKeyDown(props);
        },

        onExit() {
          if (popupRef.value) {
            popupRef.value[0].destroy();
            popupRef.value = null;
          }

          component.destroy();
        },
      };
    },
  };
}
